'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _redial = require('redial');

var _reactRedux = require('react-redux');

var _glamor = require('glamor');

var _AccountOption = require('@quixeltools/quixel-ui-library/dist/components/megascans/account/AccountOption');

var _AccountOption2 = _interopRequireDefault(_AccountOption);

var _css = require('@quixeltools/quixel-ui-library/dist/utils/css');

var _polyfluid = require('@quixeltools/quixel-ui-library/dist/utils/polyfluid');

var _license = require('redux/modules/license');

var _utils = require('utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var title = (0, _glamor.css)({
  color: _css.colors.white,
  fontWeight: 300
}, (0, _polyfluid.polyfluid)({
  fontSize: {
    smallMedium: 1.6875,
    large: [1.6875, 2.25]
  },
  marginBottom: {
    smallMedium: 1.6875,
    large: [1.6875, 2.25]
  }
}));

var accountOption = (0, _glamor.css)({
  marginBottom: (0, _css.unitRem)(1.5)
});

var icon = (0, _glamor.css)((0, _polyfluid.polyfluid)({
  width: {
    smallMedium: 3.375,
    large: [3.375, 4.5]
  },
  height: {
    smallMedium: 3.375,
    large: [3.375, 4.5]
  }
}));

var cf = function cf(path) {
  return 'https://d3uwib8iif8w1p.cloudfront.net/megascans/' + path;
};

var DownloadsSection = function (_React$Component) {
  (0, _inherits3.default)(DownloadsSection, _React$Component);

  function DownloadsSection() {
    (0, _classCallCheck3.default)(this, DownloadsSection);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DownloadsSection.__proto__ || (0, _getPrototypeOf2.default)(DownloadsSection)).call(this));

    _this.state = {
      platform: 'Windows'
    };

    _this.handleOfflineLicenseDownload = _this.handleOfflineLicenseDownload.bind(_this);
    _this.handleBridgeOfflineLicenseDownload = _this.handleBridgeOfflineLicenseDownload.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(DownloadsSection, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ platform: (0, _utils.detectOperatingSystem)() });
    }
  }, {
    key: 'handleOfflineLicenseDownload',
    value: function handleOfflineLicenseDownload() {
      this.props.loadLicenseData();
    }
  }, {
    key: 'handleBridgeOfflineLicenseDownload',
    value: function handleBridgeOfflineLicenseDownload() {
      this.props.loadBridgeLicenseData();
    }
  }, {
    key: 'render',
    value: function render() {
      var platform = this.state.platform;

      // const bridge = this.props.softwares.bridgeUpdater;

      var studio = this.props.softwares.mixerUpdater;

      // const bridgeLatest = getLatestVersion(bridge, platform);
      var bridgeLatest = _utils.bridgeBuilds[platform.toLowerCase()];
      var studioLatest = (0, _utils.getLatestVersion)(studio, platform);
      var accountOptionButtons = platform !== 'Linux' ? [{ label: 'Download ' + (0, _utils.prettyVersion)(studioLatest.Version), href: platform.toLowerCase() === 'windows' ? studioLatest.Url : studioLatest.UrlMac }, { label: 'Other Versions', to: '/products/mixer' }] : [{ label: 'Other Versions', to: '/products/mixer' }];

      var bridgeOptionsButtons = [{
        label: 'Download',
        href: bridgeLatest
      }];

      if (this.props.subscription && !this.props.subscription.doesGetCharged) {
        accountOptionButtons.push({
          label: 'Offline License',
          onClick: this.handleOfflineLicenseDownload
        });

        bridgeOptionsButtons.push({
          label: 'Offline License',
          onClick: this.handleBridgeOfflineLicenseDownload
        });
      }
      console.log(platform);
      return _react2.default.createElement(
        'section',
        { className: this.props.className },
        _react2.default.createElement(
          'h1',
          { className: title },
          'Downloads'
        ),
        _react2.default.createElement(
          'div',
          { className: accountOption },
          _react2.default.createElement(_AccountOption2.default, {
            icon: _react2.default.createElement('img', { className: icon, src: cf('icons/mixer_icon_2048_preview.png') }),
            title: 'Quixel Mixer',
            buttons: accountOptionButtons
          })
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _glamor.css)(accountOption, { marginBottom: 0 }) },
          _react2.default.createElement(_AccountOption2.default, {
            icon: _react2.default.createElement('img', { className: icon, src: 'https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/bridge_icon_2048.png' }),
            title: 'Megascans Bridge',
            buttons: bridgeOptionsButtons
          })
        )
      );
    }
  }]);
  return DownloadsSection;
}(_react2.default.Component);

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    subscription: state.user.subscription
  };
}, { loadLicenseData: _license.loadLicenseData, loadBridgeLicenseData: _license.loadBridgeLicenseData })(DownloadsSection);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DownloadsSection/DownloadsSection.jsx
// module id = 2510
// module chunks = 0